import { useTranslation } from 'react-i18next'
import { CloseIcon, LogoutIcon, MenuIcon, Span } from '@/components/atoms'
import { UserCircleIcon } from '@/components/atoms/icons'
import { LanguageSwitcher } from '../language-switcher'
import { useAuth } from '@/shared/hooks/use-auth'
import { useMobileMenu } from './mobile-menu.hook'

interface MobileMenuProps {
  showProfileIcon?: boolean
}

export function MobileMenu({ showProfileIcon = false }: MobileMenuProps) {
  const { isOpen, open, close } = useMobileMenu()
  const { logout, loading } = useAuth()
  const { t } = useTranslation()

  return (
    <>
      <button
        onClick={isOpen ? close : open}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        className="text-indigo-base flex items-center md:hidden"
      >
        {isOpen ? (
          <CloseIcon className="h-6 w-6" />
        ) : showProfileIcon ? (
          <span className="flex size-8 items-center justify-center rounded-lg bg-white">
            <UserCircleIcon className="size-6" />
          </span>
        ) : (
          <MenuIcon className="h-8 w-8" />
        )}
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-[var(--z-menu-overlay)] bg-neutral-900/40 backdrop-blur-sm transition-opacity duration-300 md:hidden lg:hidden"
          style={{ top: 'calc(var(--header-h) + var(--sat, 0px))' }}
          onClick={close}
          aria-hidden="true"
        />
      )}

      <div
        className={`fixed top-[calc(var(--header-h)_+_var(--sat,_0px))] right-0 z-[var(--z-header)] h-full max-h-[calc(100dvh_-_var(--header-h)_-_var(--sat,_0px))] w-72 w-full bg-white shadow-xl transition-transform duration-300 ease-in-out sm:max-w-sm sm:rounded-l-xl md:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="border-t-2 border-neutral-100">
          <div className="px-6 py-3 pt-6">
            <LanguageSwitcher variant="toggle" />
          </div>

          <button
            onClick={() => {
              close()
              logout()
            }}
            disabled={loading}
            data-testid="logout-button-mobile"
            aria-label="Logout"
            className="flex items-center gap-2 rounded-md px-6 py-3 text-base text-black transition-colors hover:bg-gray-100"
          >
            <Span>{t('home.logout')}</Span>
            <LogoutIcon className="text-indigo-base h-6 w-6" />
          </button>
        </div>
      </div>
    </>
  )
}
